<form [formGroup]="quoteForm">
  <div class="row pad-top-40">
    <div class="row column twelve lg-push-two md-eight md-push-two">
      <h2 class="font-weight-bold" dsContent [contentPath]="'policy.quoteOrBindHeader'"></h2>
      <p class="pad-top-20" dsContent [contentPath]="'policy.quoteOrBindMessage'"></p>
    </div>
    <div class="pad-top-10 row column twelve lg-push-two md-eight md-push-two">
      <ds-radio-group
        class="quote"
        [control]="'quoteOption'"
        [selectedAnswer]="(showExpectationSettings$ | async) ?? 'bind'"
        [parentFormGroup]="quoteForm"
        [options]="coverageOptions"
      >
      </ds-radio-group>
    </div>
    <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two" aria-live="polite">
      @if (quoteForm?.value?.quoteOption?.id === 'quote') {
        <div>
          <quote-vehicle-details [formGroup]="quoteForm.get('quote')"> </quote-vehicle-details>
        </div>
      }
      @if (quoteForm?.value?.quoteOption?.id === 'bind' && !(showExpectationSettings$ | async)) {
        <div>
          <year-vin
            [vinYearForm]="quoteForm.get('bind')"
            [years$]="years$"
            [hasError$]="hasError$"
            [sameVINErrorMessage]="sameVINErrorMessage"
            [isSameVin]="isSameVin"
            [errorMessage$]="errorMessage$"
            (checkVinEvent)="verifyVin($event)"
          ></year-vin>
        </div>
      }
      <div class="pad-top-20 row column twelve">
        @if (quoteForm?.value?.quoteOption?.id === 'bind' && (showExpectationSettings$ | async)) {
          <div>
            <replace-vehicle-expectation-setting
              (exitEvent)="exit()"
              (continueEvent)="continue()"
              (sendToAgentEvent)="sendToAgent()"
            ></replace-vehicle-expectation-setting>
          </div>
        }
      </div>
    </div>
    @if (!(quoteForm?.value?.quoteOption?.id === 'bind' && (showExpectationSettings$ | async))) {
      <div>
        <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two details">
          <p dsContent [contentPath]="'policy.QQDidYouKnow'" class="inline-block"></p>
          <a href="javascript:void(0)" (click)="toggleGracePeriod()"> More details.</a>
        </div>
        <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
          <call-to-action
            [disablePrimaryButton]="
              quoteForm?.value?.quoteOption?.id === 'quote' &&
              (authorizedToSeeQuickQuote$ | async) === false
            "
            [displayBackButton]="true"
            [tertiaryButtonName]="'Cancel'"
            [disabled]="!quoteForm.get('quote')?.valid && !quoteForm.get('bind')?.valid"
            [primaryButtonName]="'Continue'"
            (primaryEvent)="getQuoteDetails()"
            (tertiaryEvent)="cancel()"
            (backEvent)="goBackOneStep()"
          ></call-to-action>
        </div>
      </div>
    }
  </div>
</form>
<ds-grace-period
  *dsPartnerAFI
  [(visible)]="displayPolicyGracePeriod"
  [activeAgents]="activeAgents$ | async"
  [user]="userState$ | async"
  [isAdvancedCustomer]="(getAdvanceAutoPolicies$ | async)?.length > 0"
></ds-grace-period>

<amfam-early-exit-modal
  [exitFlowConfimationText]="exitFlowConfimationText"
  [exitPrimaryButtonText]="exitPrimaryButtonText"
  [earlyExitFlowModalId]="exitFlowModalId"
  (stay)="stayFromExitModal()"
  (leavePage)="navigateToOverview()"
></amfam-early-exit-modal>
